/* istanbul ignore file */
import { hot } from 'react-hot-loader/root'
import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import browserHistory from 'commons/js/browserHistory'
import Routes from 'commons/js/routes/routes'
import { Provider } from 'react-redux'
import createStore from 'commons/js/util/createStore'
import RentalCarProcessContainer from './containers/RentalCarProcessContainer'
import reducers from './reducers'
import sagas from './sagas'
import RentalCarNewContainer from './containers/RentalCarNewContainer'
import RentalCarDetailContainer from './containers/RentalCarDetailContainer'

const App = () => (
    <Provider store={createStore(reducers, sagas)}>
        <Router history={browserHistory}>
            <Switch>
                <Route path={Routes.rentalCarContractPath()} component={RentalCarProcessContainer} />
                <Route path={Routes.rentalCarContractNewPath()} component={RentalCarNewContainer} />
                <Route path={Routes.rentalCarContractDetailPath()} component={RentalCarDetailContainer} />
            </Switch>
        </Router>
    </Provider>
)

export default hot(App)
